import { Blogs } from './Blogs';
import { Destinations } from './Destinations';
import { Listings } from './Listings';

export const TABS = [
  {
    slug: 'destinations',
    Component: Destinations,
  },
  {
    slug: 'listings',
    Component: Listings,
  },
  {
    slug: 'blogs',
    Component: Blogs,
  },
];
